/** Kontextvertrag der Auth-Schicht — vereint `IAuthService` und `ILoginService`. */

import { createContext } from 'react';

import type {
  App,
  ChinaAppSysGroup,
  ChinaAppSysGroupView,
  ChinaAppSysUser,
  ChinaAppSysView,
} from '@/types/entities';
import type { EntityTypes } from '@/types/enums';

export interface AuthContextValue {
  /** `true`, sobald `LoginAsync` erfolgreich war (Pendant zu `LoginDisplay.Authorized`). */
  authorized: boolean;
  initializing: boolean;
  apps: App[] | null;
  currentApp: App | null;
  user: ChinaAppSysUser | null;
  groups: ChinaAppSysGroup[] | null;
  views: ChinaAppSysView[] | null;
  profileImage: string;
  company: string;

  login(): Promise<boolean>;
  logout(): Promise<void>;
  loadApps(): Promise<App[]>;
  /** Setzt App, leert Benutzer/Gruppen, meldet neu an, navigiert nach "/" (forceLoad). */
  selectApp(app: App): Promise<void>;
  setCurrentApp(app: App | null): void;
  setViews(views: ChinaAppSysView[]): void;
  /** Erste ViewId zu einer Entität oder `null`. */
  getViewIdByEntity(entity: EntityTypes): number | null;
  /** Additive Berechtigungen; Administratoren erhalten alles. */
  getViewPermissions(viewId: number): ChinaAppSysGroupView;
  /** `true`, wenn eine Gruppe des Benutzers `IstAdministrativ` ist. */
  isAdministrator: boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
